export const hugoRating = 4.8;

export const ratings = [
    {
        name: '<b>Hugo</b>',
        rating: hugoRating,
    },
    {
        name: 'esurance',
        rating: 2.4,
    },
    {
        name: 'Root',
        rating: 1.8,
    },
    {
        name: 'GEICO',
        rating: 1.7,
    },
    {
        name: 'Allstate',
        rating: 1.5,
    },
    {
        name: 'Progressive',
        rating: 1.5,
    },
];
